import { FuseAnimate } from '@fuse';
import _ from '@lodash';
import { AppBar, DialogActions, DialogContent, Fab, IconButton, InputAdornment, TextField, Toolbar, Typography, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import EmpresaProdutoApp from 'app/ERP/EmpresaProduto/EmpresaProdutoApp';
import classNames from 'classnames';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { MdAdd, MdClose } from 'react-icons/md';
import ReactTable from "react-table";
import XAPPButton from '../../Button/XAPPButton';
import XAPPDialog from '../../Dialog/XAPPDialog';


const md = new MobileDetect(window.navigator.userAgent);

const styles = (theme) => ({
    root: {
        color: theme.palette.text.primary,
    },
    addButton: {
        position: 'absolute',
        right: 20,
        bottom: 80,
        zIndex: 99,
        color: theme.palette.text.primary,
    }
});

const newProdutoItem = {
    id: null,
    idpessoaformulario: null,
    nome: null,
    valor: 0,
    desconto: 0,
    acrescimo: 0,
    quantidade: 1,
    observacao: null,
};

class ProdutoItens extends XAPPComponent {

    state = {
        open: null
    }

    handleLookupEmpresaProduto = (_AValue) => {
        var obj = { ...this.state.open };
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj.idpessoaformulario = _AValue[0].idpessoaformulario;
            obj.nome = _AValue[0].nome;
            obj.valor = _AValue[0].valor;
            obj.unidademedida = _AValue[0].unidademedida;
        }
        else {
            obj.idpessoaformulario = null;
            obj.nome = null;
            obj.valor = null;
            obj.unidademedida = null;
        }
        this.setState(_.set({ ...this.state }, "open", obj));
    };

    getColumns = () => {
        return [
            {
                Header: "ID",
                accessor: "idpessoaformulario",
                width: 100,
                className: "justify-end"
            },
            {
                Header: "Nome",
                accessor: "nome",
                width: 300,
                className: ""
            },
            {
                Header: "Quantidade",
                accessor: "quantidade",
                width: 100,
                className: "justify-end"
            },
            {
                Header: "Valor",
                accessor: "valordescricao",
                width: 100,
                className: "justify-end"
            },
            {
                Header: "Desconto",
                accessor: "descontodescricao",
                width: 100,
                className: "justify-end"
            },
            {
                Header: "Valor total",
                accessor: "valortotaldescricao",
                width: 100,
                className: "justify-end"
            },
            {
                Header: "Ações",
                width: 60,
                natureza: [],
                Cell: row => (
                    <div className="flex items-center">
                        <XAPPButton
                            tooltip={{ "title": "Remover item", "placement": "top" }}
                            type="Icon"
                            className=""
                            variant="contained"
                            color="primary"
                            onClick={(ev) => {
                                ev.stopPropagation();
                                this.remove(row.original);
                            }}
                            iconProps={"justify-center"}
                            icon={"close"}
                        />
                    </div>
                )
            }
        ];
    }

    getDataFormatted = (_AItens) => {
        _AItens.forEach(item => {
            item.valordescricao = "R$ " + (Number.parseFloat(item.valor) + Number.parseFloat(item.acrescimo)).toFixed(2);
            item.descontodescricao = "R$ " + Number.parseFloat(item.desconto).toFixed(2);
            item.valortotaldescricao = "R$ " + ((Number.parseFloat(item.valor) + Number.parseFloat(item.acrescimo) - Number.parseFloat(item.desconto)) * Number.parseInt(item.quantidade)).toFixed(2);
        });
        return _AItens;
    }

    openDialog = () => {
        this.setState({ open: _.isNull(this.state.open) ? { ...newProdutoItem, id: new Date().getTime() } : null });
    }

    canBeSubmitted = () => {
        const { open } = this.state;
        return (
            !_.isNull(open) &&
            !_.isNull(open.idpessoaformulario) && open.idpessoaformulario !== "" &&
            !_.isNull(open.valor) && open.valor !== "" &&
            !_.isNull(open.desconto) && open.desconto !== "" &&
            !_.isNull(open.acrescimo) && open.acrescimo !== "" &&
            !_.isNull(open.quantidade) && open.quantidade !== ""
        );
    }

    handleChange = (event) => {
        this.setState({ open: _.set({ ...this.state.open }, event.target.name, event.target.value) });
    };

    save = () => {
        var AItens = JSON.parse(JSON.stringify(this.props.formulario.itens));
        AItens.push(this.state.open);
        this.props.onChange({ target: { name: "itens", value: AItens } });
        this.openDialog();
    }

    remove = (_AItem) => {
        const AItens = _.filter(this.props.formulario.itens, item => item.id !== _AItem.id);
        this.props.onChange({ target: { name: "itens", value: AItens } });
    }

    render() {
        const { classes, formulario, readOnly, xappRouteParams } = this.props;
        const form = this.state;
        return (
            <React.Fragment>
                <FuseAnimate animation="transition.slideUpIn" delay={300}>
                    <ReactTable
                        className={classNames(classes.root, ' -striped -highlight border-0')}
                        data={this.getDataFormatted(formulario.itens)}
                        columns={this.getColumns()}
                        defaultPageSize={10}
                        noDataText="Não existem registros cadastrados!"
                    />
                </FuseAnimate>
                <FuseAnimate animation="transition.expandIn" delay={300}>
                    <Fab
                        color="primary"
                        aria-label="add"
                        className={classes.addButton}
                        onClick={() => this.openDialog()}
                    >
                        <MdAdd className="text-24 text-white" />
                    </Fab>
                </FuseAnimate>
                <XAPPDialog
                    id="ProdutoItens"
                    open={!_.isNull(form.open)}
                    onClose={this.openDialog}
                    fullScreen={md.mobile() !== null}
                    fullWidth
                    maxWidth="md"
                >
                    <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <Typography variant="subtitle1 text-white">
                                {'Novo item'}
                            </Typography>
                            <div style={{ flex: 1 }} />
                            <IconButton
                                key="close"
                                aria-label="Close"
                                className="p-6"
                                onClick={() => this.openDialog()}
                            >
                                <MdClose className="text-20 text-white" />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <DialogContent classes={{ root: "px-24 py-12" }}>
                        <EmpresaProdutoApp
                            className="w-full flex flex-col mt-8 mb-16"
                            xappRouteParams={xappRouteParams}
                            selected={!_.isNull(form.open) && !_.isNull(form.open.idpessoaformulario) ? [{ ...form.open, id: form.open.idpessoaformulario }] : []}
                            label="Produto"
                            id="LookupTarefaProcessoApontamentoEmpresaProduto"
                            campoid={"idpessoaformulario"}
                            camponome={"nome"}
                            onChange={this.handleLookupEmpresaProduto}
                            required={true}
                            isLookup={true}
                            multiSelect={false}
                            readOnly={readOnly}
                        />
                        <TextField
                            className="mb-24"
                            label="Valor"
                            id="valor"
                            name="valor"
                            required
                            variant="outlined"
                            fullWidth
                            type="Number"
                            value={!_.isNull(form.open) && form.open.valor}
                            onChange={this.handleChange}
                            disabled={readOnly}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">R$</InputAdornment>
                            }}
                        />
                        <TextField
                            className="mb-24"
                            label="Desconto"
                            id="desconto"
                            name="desconto"
                            variant="outlined"
                            fullWidth
                            type="Number"
                            value={!_.isNull(form.open) && form.open.desconto}
                            onChange={this.handleChange}
                            disabled={readOnly}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">R$</InputAdornment>
                            }}
                        />
                        <TextField
                            className="mb-24"
                            label="Acréscimo"
                            id="acrescimo"
                            name="acrescimo"
                            variant="outlined"
                            fullWidth
                            type="Number"
                            value={!_.isNull(form.open) && form.open.acrescimo}
                            onChange={this.handleChange}
                            disabled={readOnly}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">R$</InputAdornment>
                            }}
                        />
                        <TextField
                            className="mb-24"
                            label="Quantidade"
                            id="quantidade"
                            name="quantidade"
                            variant="outlined"
                            fullWidth
                            value={!_.isNull(form.open) && form.open.quantidade}
                            onChange={this.handleChange}
                            disabled={readOnly}
                            required
                            type="Number"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextField
                            className="mb-24"
                            label="Observações"
                            id="observacao"
                            name="observacao"
                            variant="outlined"
                            fullWidth
                            value={!_.isNull(form.open) && form.open.observacao}
                            onChange={this.handleChange}
                            disabled={readOnly}
                            multiline
                            rows={3}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </DialogContent>
                    <AppBar position="static" elevation={3} color="textSecondary">
                        <Toolbar className="flex w-full justify-end min-h-0">
                            <DialogActions>
                                <XAPPButton
                                    type="Button"
                                    className="bg-green hover:bg-green text-white mr-8"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => this.save()}
                                    disabled={!this.canBeSubmitted()}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"save"}
                                    label={md.mobile() === null && md.tablet() === null ? 'Salvar' : ''}
                                />
                            </DialogActions>
                        </Toolbar>
                    </AppBar>
                </XAPPDialog>
            </React.Fragment>

        )
    };
}


export default withStyles(styles, { withTheme: true })(ProdutoItens);
